import { render, staticRenderFns } from "./LowestStats.vue?vue&type=template&id=67782b14&scoped=true"
import script from "./LowestStats.vue?vue&type=script&lang=js"
export * from "./LowestStats.vue?vue&type=script&lang=js"
import style0 from "./LowestStats.vue?vue&type=style&index=0&id=67782b14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67782b14",
  null
  
)

export default component.exports